<template>
  <div class="product-container">
    <img :src="padlockIcon" alt="Padlock Icon" />
    <div class="text">
      <a
        :href="$t('components.productMessage.caseStudiesLink.href')"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('components.productMessage.caseStudiesLink.linkText') }}
      </a>
      {{ $t('components.productMessage.caseStudiesLink.text') }}
    </div>
  </div>
</template>

<script>
import padlockIcon from '@/assets/icons/padlock-icon.png';

export default {
  data() {
    return {
      padlockIcon,
    };
  },
};
</script>

<style lang="less" scoped>
.product-container {
  display: inline-block;
  position: relative;
  overflow: hidden;
  margin: 25px auto 20px;
  max-width: 480px;
  padding: 16px 20px 20px 90px;
  background-color: #ffffff;
  border: 1px solid #e8e8ea;
  border-radius: 8px;
  font-size: 16px;
  font-family: @regular-font;
  text-align: left;
}

img {
  position: absolute;
  left: 4px;
  top: 4px;
  width: 76px;
}

.link {
  color: #215cb6;
  text-decoration: underline;
}

@media (max-width: 416px) {
  img {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
